module.exports = __webpack_public_path__ + "media/react/app_submitter/components/PhotoReader/assets/compact-camera-294e9613416ced5da0c83780dd1aa22d.png";